// import { subSchedule } from './../../redux/subscriptionsAndPlans/actions';
// import { APICore } from './apiCore';

// const api = new APICore();

// export function subPlanList(data: any) {
//     return api.get('/subscription/plan/list');
// }

// export function subPlanAdd(data: any) {
//     return api.create('/subscription/plan/create', data);
// }

// export function subPlanDelete(data: any) {
//     return api.delete('/subscription/plan/delete', data);
// }

import { APICore } from './apiCore';

const api = new APICore();

export function subPlanList(data?: any) {
    return api.create('/subscription/plan/list', data);
}

export function subList(data?: any) {
    return api.create('/subscription/list', data);
}

export function subPlanAdd(data: any) {
    return api.create('/subscription/plan/add', data);
}

export function subPlanDelete(data: any) {
    return api.delete('/subscription/plan/delete', data);
}

export function subAdd(data: any) {
    return api.create('/subscription/add', data);
}

export function subSchedule(data: any) {
    return api.create('/subscription/schedule', data);
}

// 🔹 Update Subscription Plan (PUT)
export function subPlanUpdate(data: any) {
    return api.update('/subscription/plan/update', data);
    // data example:
    // {
    //   "plan_id": "f922edd4-79d4-4236-a7c4-0cea359ab691",
    //   "plan_name": "Test",
    //   "description": "testing api",
    //   "billing_cycle": "yearly"
    // }
}

// 🔹 Update Subscription Plan Status (PATCH is better for partial updates)
export function subPlanUpdateStatus(data: any) {
    return api.update('/subscription/plan/update-status', data);
    // data example:
    // {
    //   "plan_id": "f922edd4-79d4-4236-a7c4-0cea359ab691",
    //   "is_active": true
    // }
}

export function subAddModules(data: any) {
    return api.update('/subscription/add/modules', data);
}
